import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'
// import HelloWorld from '@/components/HelloWorld'
import Contact from '@/components/Contact'
import Edologic from '@/components/Edologic'
import Home from '@/components/Home'
import Impressum from '@/components/Impressum'
import Produkte from '@/components/Produkte'
import Service from '@/components/Service'
import Crossfind from '@/components/Crossfind'
import Examenis from '@/components/Examenis'
import Softwareentwicklung from '@/components/Softwareentwicklung'
import Kreation from '@/components/Kreation'
import Rechenzentrum from '@/components/Rechenzentrum'
import Blog from '@/components/Blog'
import BlogContent from '@/components/BlogContent'
import UeberUns from '@/components/UeberUns'
import SurfandScan from '@/components/SurfandScan'
import Datenschutz from '@/components/Datenschutz'
import SasOne from '@/components/SasOne'
import newSite from '@/components/newSite'
import DatenschutzNew from '@/components/DatenschutzNew'
import ImpressumNew from '@/components/ImpressumNew'
import Articles from '@/components/Articles'
import examenisnew from '@/components/examenisnew'
import HomeNew from '@/components/HomeNew'
import edologic2021 from '@/components/edologic2021'

Vue.use(Router)
Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})
Vue.use(VueAnalytics, {
  id: 'UA-4515910-4'
})
export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: edologic2021
    },
    {
      path: '/edologic2021',
      name: 'Home',
      component: Home
    },
    {
      path: '/HomeNew',
      name: 'HomeNew',
      component: HomeNew
    },
    {
      path: '/SurfAndScan',
      name: 'SasOne',
      component: SasOne
    },
    {
      path: '/newSite',
      name: 'newSite',
      component: newSite
    },
    {
      path: '/examenisnew',
      name: 'examenisnew',
      component: examenisnew
    },
    {
      path: '/DatenschutzNew',
      name: 'DatenschutzNew',
      component: DatenschutzNew
    },
    {
      path: '/ImpressumNew',
      name: 'ImpressumNew',
      component: ImpressumNew
    },
    {
      path: '/Articles',
      name: 'Articles',
      component: Articles
    },
    {
      path: '/home',
      name: 'Home2',
      component: Home
    },
    {
      path: '/kontakt',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/edologic',
      name: 'Edologic',
      component: Edologic
    },
    {
      path: '/datenschutz',
      name: 'Datenschutz',
      component: Datenschutz
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum
    },
    {
      path: '/produkte',
      name: 'Produkte',
      component: Produkte
    },
    {
      path: '/produkte/crossfind',
      name: 'Crossfind',
      component: Crossfind
    },
    {
      path: '/produkte/examenis',
      name: 'Examenis',
      component: Examenis
    },
    {
      path: '/produkte/surfandscan',
      name: 'SurfandScan',
      component: SurfandScan
    },
    {
      path: '/service/rechenzentrum',
      name: 'Rechenzentrum',
      component: Rechenzentrum
    },
    {
      path: '/service/softwareentwicklung',
      name: 'Softwareentwicklung',
      component: Softwareentwicklung
    },
    {
      path: '/service/kreation',
      name: 'Kreation',
      component: Kreation
    },
    {
      path: '/ueberuns',
      name: 'UeberUns',
      component: UeberUns
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/blog/:blogTitel/:blogId',
      name: 'BlogContent',
      component: BlogContent
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js